import type { Severity } from '../../view-models';
import type React from 'react';

export interface ConflictAlertSeverityBadgeProps {
  severity: Severity;
  count?: number;
}

export function ConflictAlertSeverityBadge({
  severity,
  count,
}: ConflictAlertSeverityBadgeProps): React.JSX.Element | null {
  const map: Record<Severity, { label: string; cls: string }> = {
    critical: { label: 'CRÍTICO', cls: 'sev sev--critical' },
    high: { label: 'ALTO', cls: 'sev sev--high' },
    medium: { label: 'MÉDIO', cls: 'sev sev--medium' },
    low: { label: 'BAIXO', cls: 'sev sev--low' },
  };
  const m = map[severity];
  if (m === undefined) return null;
  return (
    <span className={m.cls}>
      {m.label}
      {count !== null && count !== undefined ? ` (${count})` : ''}
    </span>
  );
}
